export var DateFormat=(dd)=>{
    let d=new Date(dd);
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`
}
